import { useEffect } from 'react';

// Ref-counted: camera panel + a viewer can be dark at the same time
let darkCount = 0;

/**
 * Paints the page canvas black while mounted. On iOS standalone the canvas
 * shows in the home-indicator strip outside the layout viewport, so dark
 * full-screen surfaces (camera, media viewers) must dye it to match —
 * everything else rides the cream default from index.css.
 */
export function useDarkCanvas(active: boolean = true) {
  useEffect(() => {
    if (!active) return;
    darkCount += 1;
    document.body.style.backgroundColor = '#000000';
    return () => {
      darkCount -= 1;
      if (darkCount === 0) document.body.style.backgroundColor = '';
    };
  }, [active]);
}
